import { getGuessStatuses } from './statuses'
import { solutionIndex, unicodeSplit } from './words'
import { GAME_TITLE } from '../constants/strings'
import { MAX_CHALLENGES } from '../constants/settings'
import { UAParser } from 'ua-parser-js'

const webShareApiDeviceTypes: string[] = ['mobile', 'smarttv', 'wearable']
const parser = new UAParser()
const browser = parser.getBrowser()
const device = parser.getDevice()

export const shareStatus = (
  guesses: string[],
  lost: boolean,
  isHardMode: boolean,
  isDarkMode: boolean,
  isHighContrastMode: boolean,
  handleShareToClipboard: () => void
) => {
  const textToShare =
    `@${GAME_TITLE} ${solutionIndex} ${
      lost ? 'X' : guesses.length
    }/${MAX_CHALLENGES}${isHardMode ? '*' : ''}\n\n` +
    generateEmojiGrid(guesses, getEmojiTiles(isDarkMode, isHighContrastMode))

  const shareData = { text: textToShare }

  let shareSuccess = false

  try {
    if (attemptShare(shareData)) {
      navigator.share(shareData)
      shareSuccess = true
    }
  } catch (error) {
    shareSuccess = false
  }

  if (!shareSuccess) {
    navigator.clipboard.writeText(textToShare)
    handleShareToClipboard()
  }
}

export const generateEmojiGrid = (guesses: string[], tiles: string[]) => {
  return guesses
    .map((guess) => {
      const status = getGuessStatuses(guess)
      const splitGuess = unicodeSplit(guess)

      return splitGuess
        .map((_, i) => {
          switch (status[i]) {
            case 'correct':
              return tiles[0]
            case 'present':
              return tiles[1]
            default:
              return tiles[2]
          }
        })
        .join('')
    })
    .join('\n')
}

const attemptShare = (shareData: object) => {
  return (
    // Deliberately exclude Firefox Mobile, because its Web Share API isn't working correctly
    browser.name?.toUpperCase().indexOf('FIREFOX') === -1 &&
    webShareApiDeviceTypes.indexOf(device.type ?? '') !== -1 &&
    navigator.canShare &&
    navigator.canShare(shareData) &&
    navigator.share
  )
}

const getEmojiTiles = (isDarkMode: boolean, isHighContrastMode: boolean) => {
  let tiles: string[] = []
  tiles.push(isHighContrastMode ? '🟧' : '🟩')
  tiles.push(isHighContrastMode ? '🟦' : '🟨')
  tiles.push(isDarkMode ? '⬛' : '⬜')
  return tiles
}

export const participateRanking = (
  lost: boolean
) => {
  if (lost) {
    return;
  }

  // @ts-ignore: Object is possibly 'null'.
  const handle = document.getElementById('handle').value;
  if (handle == null || handle.length === 0 || handle.indexOf('@') === -1) {
    return;
  }

  if (localStorage.getItem('submitGameForRanking') != null) {
    return;
  }

  // @ts-ignore: Object is possibly 'null'.
  const elapsedTime = parseFloat(localStorage.getItem('elapsedTime'));
  // @ts-ignore: Object is possibly 'null'.
  const gameState = JSON.parse(localStorage.getItem('gameState'));

  const payload = {
    handle: handle,
    elapsedTime: elapsedTime,
    guesses: gameState.guesses.length,
    solution: gameState.solution,
  }

  fetch("https://us-central1-scholardle.cloudfunctions.net/submit_game_for_ranking", {
    method: "POST",
    headers: {'Content-Type': 'application/json'}, 
    body: JSON.stringify(payload)
  }).then(res => {
    localStorage.setItem('hasSubmittedGameForRanking', 'true');

    const html = `
      <div class="py-4 text-center">
        <p>Thanks for participating!</p>
        <p>Follow us on Twitter to see the results - <a class="underline font-bold" href="https://twitter.com/Writefullapp">@writefullapp</a>.</p>
      </div>
    `
    // @ts-ignore: Object is possibly 'null'.
    document.querySelector('#ranking-div').innerHTML = html;
  });
}